import { render, staticRenderFns } from "./App-Fail.vue?vue&type=template&id=c980b8ba&scoped=true&"
import script from "./App-Fail.vue?vue&type=script&lang=js&"
export * from "./App-Fail.vue?vue&type=script&lang=js&"
import style0 from "./App-Fail.vue?vue&type=style&index=0&id=c980b8ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c980b8ba",
  null
  
)

export default component.exports